<template>
    <modal
        v-if="splitLoadModal"
        :title="$t('OrderCurrent.actions.split_load')"
        @close-request="clearSelected"
        closable
      >
        <table-element
          :isShowFilter="true"
          :title="$t('OrderCurrent.modal.selected_orders')"
          :fields="fieldsObjBIL"
          :arrOfElement="selectedFull"
          :sortSpacing="0"
          class="card mx-2 mt-4"
        >
          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{selectedFull.length}}</p>
          </template>

          <template #pre-body-content>
            <div class="m-2">
              <label for="splitLoadPrice">{{$t('OrderCurrent.modal.splitLoad.splitLoadPrice')}}</label>
                <regular-input
                  min="0"
                  v-model="splitLoadPrice"
                  type="number"
                  placeholder="Load Price"
                />
              <button class="mt-1 btn btn-kne-orange" @click="applySplitLoad">{{$t('OrderCurrent.modal.splitLoad.applyAll')}}</button>
            </div>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index"
            :class="{
              'drop': order.status === 'Drop',
              'cancel': order.status === 'Cancel',
              'waiting': order.status === 'Attente',
              'pick': order.status === 'Pick',
              'transit': order.status === 'Transit',
              'dispatch': order.status === 'Dispatch',
              'reject': order.status === 'Reject',
              'inspection': order.status === 'Inspection',
              'transfered': order.status === 'Transférée'
              }">
              <td class="pt-2">
                <span class="nowrap">
                  <hover-tool-tip
                  v-if="!order.historySync || !checkHistorySyncDrops(order.historySync)"
                  :text="`<div>
                            ${$t('OrderCurrent.modal.orderNotCompleted')}
                          </div>`"
                  :top="true"
                  :right="true"
                  :iconColor="'red'"
                  :iconClass="'fa-exclamation-triangle'"
                  clickable
                  />
                  {{ order.orderNumber }}
                  <hover-tool-tip
                    :text="`<div>
                              ${order.source || '-'}
                              <br>${getDate(order.creationDate) || '-'}
                              <br>${order.make || '-'} ${order.model || '-'} ${order.year || '-'}
                            </div>`"
                    :top="true"
                    :right="true"
                    clickable
                  />
                  <hover-tool-tip
                    :text="generateTooltip(order)"
                    :right="true"
                    :top="true"
                    :iconColor="'green'"
                    :iconClass="'fa-receipt'"
                    clickable
                  />
                </span>
              </td>
              <td class="nowrap">
                <span>
                  {{shortenString($realName(order, 'payer'))}}
                  <hover-tool-tip
                  :text="`<div>
                            <p>
                              ${order.transmitterAddress || '-'} ${order.transmitterCity || '-'}, ${order.transmitterProvince || '-'} ${order.transmitterPostcode || '-'}, ${order.transmitterCountry || '-'}
                            </p>
                            ->
                            <p>
                              ${order.receiverAddress || '-'} ${order.receiverCity || '-'}, ${order.receiverProvince || '-'} ${order.receiverPostcode || '-'}, ${order.receiverCountry || '-'}
                            </p>
                          </div>`"
                  right
                  :top="true"
                  clickable
                  />
                </span>
              </td>
              <td>
                {{order.numRef || "No Reference"}}
              </td>
              <td>
                <regular-input
                min="0"
                :value="order.price"
                @input="order.price = $event"
                type="number" :placeholder="$t('OrderCurrent.price')"/>
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="flex-row my-2" key="post-body-content">
              <div>
                <button @click="saveSplitLoad()" class="btn btn-kne-orange m-1">{{$t('OrderCurrent.modal.splitLoad.saveLoadPrice')}}</button>
              </div>
            </div>
          </template>
        </table-element>
    </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import regularInput from '../../basic-components/regularInput.vue'
import regularSelect from '../../basic-components/regularSelect.vue'
import TableElement from '../Table-component/Table-Element.vue'
import hoverToolTip from '../../basic-components/hoverToolTip.vue'

import { db } from '../../../../firebase'

export default {
    name: 'SplitLoadModal',
    components: {
        Modal,
        TableElement,
        regularInput,
        regularSelect,
        hoverToolTip
    },

    data () {
        return {
            fieldsObjBIL: [
                {
                    text: this.$t('OrderCurrent.order'),
                    type: 'orderNumber',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.payer'),
                    type: 'payerName',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.reference'),
                    type: 'numRef',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.price'),
                    type: 'price',
                    value: ''
                }
            ],
            splitLoadPrice: 0,
            selectedFull: []
        }
    },

    props: {
        splitLoadModal: Boolean,
        arrOfOrder: {
          type: Array,
          required: true
        }
    },

    methods: {
        checkHistorySyncDrops (historysync) {
            let dropFlag = true
            for (const key in historysync) {
                if (!historysync[key].dropDate) {
                dropFlag = false
                break
                }
            }
            return dropFlag
        },
        applySplitLoad () {
            const splitPrice = this.splitLoadPrice / this.selectedFull.length
            this.selectedFull.forEach(order => {
                order.price = splitPrice
            })
        },
        saveSplitLoad () {
            this.selectedFull.forEach(order => {
                const cleanOrder = { ...order }
                delete cleanOrder['.key']

                db.ref('database/transporter/' + this.companyUID + '/deliveries/' + order.orderNumber).update(cleanOrder)
            })
            this.clearSelected()
        },
        getDate: function (timestamp) {
            var date = new Date(timestamp)
            return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
        },
        shortenString (text) {
          if (typeof text === 'undefined') return text
          else {
            let subString = text.substring(0, 22)
            if (text.length > 22) subString += '...'
            return subString
          }
        },
        generateTooltip (order) {
            if (!order) return '-'

            let htmlParts = []

            if (Array.isArray(order.fees) && order.fees.length > 0) {
                order.fees.forEach(fee => {
                if (fee.amount != null && fee.text) {
                    htmlParts.push(`${fee.text}: ${fee.amount}$`)
                }
                })
            }

            if (htmlParts.length === 0) return '-'

            return `<p>${htmlParts.join('<br>')}</p>`
        },
        clearSelected () {
          this.$emit('closeSplitLoadModal')
          this.selectedFull = []
        },
        formatDate (date) {
          let fdate = new Date(date)
          fdate = fdate.getFullYear() + '-' + ('0' + (fdate.getMonth() + 1)).slice(-2) + '-' + ('0' + fdate.getUTCDate()).slice(-2)

          return fdate
        }
    },

    computed: {
      companyUID () {
        return this.$store.state.authorization.company
      }
    },

    watch: {
      arrOfOrder: {
        immediate: true,
        handler (val) {
          this.selectedFull = Array.isArray(val) ? val : []
        }
      }
    }
}
</script>
